'use client';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { AddressTracker } from './AddressTracker';
/**
 * 住所登録完了を検知するコンポーネント
 * クエリパラメータから住所登録完了を判定し、アナリティクスを送信する
 */
function AddressRegistrationTracker() {
  const searchParams = useSearchParams();
  const trackedRef = useRef(false);
  useEffect(() => {
    // 既に計測済みの場合は何もしない
    if (trackedRef.current) return;
    // 住所登録完了のクエリパラメータがある場合
    const addressCompleted = searchParams.get('address_completed');
    if (addressCompleted === 'true') {
      trackedRef.current = true;

      // 現在のURLからくじイベントIDを取得
      const lotteryId = extractLotteryIdFromCurrentUrl();

      // 住所登録完了を記録
      AddressTracker.trackComplete('address_form', lotteryId);

      // URLからクエリパラメータを削除（履歴を汚さないため）
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('address_completed');
      window.history.replaceState({}, '', newUrl.toString());
    }
  }, [searchParams]);
  return null; // このコンポーネントは何も描画しない
}
/**
 * 現在のURLからくじイベントIDを抽出する
 */
const extractLotteryIdFromCurrentUrl = (): number | undefined => {
  const match = window.location.pathname.match(/\/lotteries\/(\d+)/);
  return match ? Number.parseInt(match[1], 10) : undefined;
};
export default AddressRegistrationTracker;
